import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	filtro: {
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
	},
	lista: [],
	listaMotorista: [],
	listaCidade: [],
	listaContaBancaria: [],
	listaForma: [{
		id: 1,
		valor: 'Depósito'
	}, {
		id: 2,
		valor: 'Dinheiro'
	}, {
		id: 3,
		valor: 'Cheque'
	}]
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'DEVOLUCAO_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'DEVOLUCAO_FILTRO':
			return { ...state, filtro: action.payload };

		case 'DEVOLUCAO_LISTADO':
			return { ...state, lista: action.payload.data };


		case 'DEVOLUCAO_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		case 'DEVOLUCAO_MOTORISTA_SELECT_LISTADO':
			return { ...state, listaMotorista: action.payload.data };

		case 'DEVOLUCAO_CONTA_BANCARIA_SELECT_LISTADO':
			return { ...state, listaContaBancaria: action.payload.data };

		case 'DEVOLUCAO_CIDADE_SELECT_LISTADO':
			return { ...state, listaCidade: action.payload.data };

		default:
			return state;
	}
}
